import React, {Fragment, useEffect, useState, useRef} from 'react'
import { formatPhone } from '../shared/genericFunctions';
import { constants } from '../../App.constants';
import moment from 'moment-timezone'
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button';
import { embeddedUrl } from "../../store/actions/waiverActions";
import { CircularProgress } from "@material-ui/core";
import { useDispatch } from 'react-redux';
import { withSnackbar } from 'notistack';
import { currentPricing } from '../docs/memberBenefits';

const styles = (theme) => ({
    marginTop2: {
        marginTop: theme.spacing(2)
    },
})
const ContractSign = ({regTitle, error , memberInfo, selectedPricing, classes, nonce, sid, startDate, endDate, isEligibleForAddon, confirmedDetails, placeOfBirth}) => {
    
    const [signUrl, setSignUrl] = useState(null);
    const [clicked, setClicked] = useState(false);
    const [loading, setLoading] = useState(false);
    const [iframeLoaded, setIframeLoaded] = useState(false)
    const frameRef = useRef(null);
    const [errorMsg, setErrorMsg] = useState(null);
    const dispatch = useDispatch()
    
    const handleIframeLoad = () => {
        setIframeLoaded(true);
    };

    useEffect(()=>{
        if(error){
            setSignUrl(null);
            setLoading(false);
            setClicked(false)
            setErrorMsg(`Incomplete contract, please try again`)
        }
    }, [error])

    const beginSigning = () => {
        setLoading(true);
        setErrorMsg(null);
        const returnUrl =
        `${window.location.origin}/#/docusign-bridge` +
        `?nonce=${encodeURIComponent(nonce)}` +
        `&sid=${encodeURIComponent(sid)}`+
        `&memId=${encodeURIComponent(memberInfo?.id)}`+
        `&startDate=${encodeURIComponent(startDate)}`+
        `&endDate=${encodeURIComponent(endDate)}`+
        `&selectedPricing=${encodeURIComponent(selectedPricing)}`+
        `&isEligibleForAddon=${encodeURIComponent(isEligibleForAddon)}`

        const { DOCUSIGN_CLIENT_USER_ID, DOCUSIGN_TEMPLATE_ID_RENEW } = constants;
        const { name, email } = memberInfo
        // The confirm-details step saved these to the member record; sign
        // with exactly those values, never the merged account data (where an
        // empty date became today's date and Stripe's address object leaked in).
        const d = confirmedDetails || {}
        const signerName = [d.firstName, d.lastName].filter(Boolean).join(' ') || name
        const contractDate = (iso) => (iso && moment(iso, 'YYYY-MM-DD', true).isValid() ? moment(iso, 'YYYY-MM-DD').format('MM/DD/YYYY') : undefined)

        try {

            const prefill = {
                "phone_field": d.phoneNumber ? formatPhone(d.phoneNumber) : undefined,
                "dob_field": contractDate(d.dateOfBirth),
                "emergency_contact_field": d.emergencyContactName || undefined,
                "emergency_contact_phone": d.emergencyContact ? formatPhone(d.emergencyContact) : undefined,
                "pob_field": placeOfBirth || undefined,
                "membership_field": regTitle || undefined,
                "home_address_field": d.address || undefined,
                "mailing_address_field": d.mailingAddress || d.address || undefined,
                "initiation_fee_golf": currentPricing.Golf.initiation_fee,
                "initiation_fee_social": currentPricing.Social.initiation_fee,
                "member_dues_golf": currentPricing.Golf.amount,
                "member_dues_social": currentPricing.Social.amount,
                "golf_add_on": currentPricing.Golf_Addon.amount,
                "social_add_on": currentPricing.Social_Addon.amount,
                "primary_member_name_field": signerName
                
            }
            const signer = { "name": signerName, "email": email, "roleName": "Member", "clientUserId": "s1-embed" }

            dispatch(embeddedUrl(DOCUSIGN_CLIENT_USER_ID, DOCUSIGN_TEMPLATE_ID_RENEW, signer, prefill, returnUrl, (err, payload) => {

                if(!err && payload.data){
                    setSignUrl(payload.data.url);
                }
                setLoading(false);
            }))
        
        } catch (e) {
         setErrorMsg(e?.message || "Failed to start signing");
         setLoading(false);
        }
    }

    return <>
        <Grid container direction="column" justifyContent="center" className={classes.marginTop10}>
            <Grid item className={classes.marginTop2}>
                {!signUrl ? (<Fragment>
                    {<Button type="button" onClick={beginSigning}  fullWidth disabled={clicked || loading || !selectedPricing } variant="contained" size="large" name="TermsEsignBtn" color="primary" >
                        {loading ? <span>Starting, please wait...<CircularProgress size={'14px'}></CircularProgress></span> : "Review and Complete Renewal"}
                    </Button> }
                
                    {errorMsg && <div style={{ color: "#a83232" }}>{errorMsg}</div>}
                    <p style={{ fontSize: 12, color: "#666" }}>
                        Please complete the e-sign process to renew your membership. Click to start signing the renewal contract.
                    </p>
                </Fragment>) : (
                <Fragment>
                    {!iframeLoaded && <span>Prefilling details..<CircularProgress size={'14px'}></CircularProgress></span>}
                        <iframe
                    ref={frameRef}
                    onLoad={handleIframeLoad}
                    title="DocuSign Signing"
                    src={signUrl}
                    style={{ width: "100%", height: "90vh", border: 0 }}
                    allow="clipboard-read; clipboard-write"
                    />
                    </Fragment>
                    
                )}
            </Grid>
        </Grid> 
    </>
}

export default withStyles(styles)(withSnackbar(ContractSign))